import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Grid from '@material-ui/core/Grid';
import { Formik } from 'formik';
import Button from '@material-ui/core/Button';

import FormSelectField from 'components/FormFields/FormSelectField';
import FormCheckboxGroup from 'components/FormCheckboxGroup/FormCheckboxGroup';

import { MovementsStore, MovemensData } from 'stores/account/movementsStore';

interface Props {
  store: MovementsStore;
}

const MovementsFilter: React.FC<Props> = ({ store }) => {
  const { t } = useTranslation();
  const { data } = store;
  const [filterChange, setFilterChange] = useState(false);

  const onSubmit = async (values: MovemensData) => {
    await store.handleFilterSubmit(values);
    setFilterChange(false);
  };

  return (
    <Formik initialValues={data!} enableReinitialize={true} onSubmit={onSubmit}>
      {(formikProps) => (
        <Grid container>
          <Grid item xs={12}>
            <FormSelectField
              name="filter.portfolio"
              label={t('general_portfolio')}
              afterChange={() => setFilterChange(true)}
              options={data!.filter.options.portfolios.map((p) => ({
                value: p,
                label: t(`accountDetail_movements_portfolio_${p}`),
              }))}
            />
          </Grid>
          <Grid item xs={12}>
            <FormSelectField
              name="filter.period"
              label={t('accountDetail_movements_period')}
              afterChange={() => setFilterChange(true)}
              options={data!.filter.options.periods.map((p) => ({
                value: p,
                label: t(`accountDetail_movements_period_${p}`),
              }))}
            />
          </Grid>
          <Grid item xs={12} container spacing={0} justifyContent="center">
            <Grid item xs={12}>
              <FormCheckboxGroup
                key={`filter.types`}
                name={`filter.types`}
                label={t(`general_type`)}
                values={formikProps.values.filter.types}
                optPrefix="accountDetail_movements_filter_"
                options={data!.filter.options.types}
                afterChange={() => setFilterChange(true)}
                noMargin
              />
            </Grid>
            <Button
              variant={filterChange ? 'contained' : 'outlined'}
              onClick={formikProps.submitForm}
              style={{ margin: '0 auto' }}
            >
              {t('accountDetail_movements_useFilter')}
            </Button>
          </Grid>
        </Grid>
      )}
    </Formik>
  );
};

export default MovementsFilter;
